import { Card, FormGroup, Icon, Label, Row, Table, Text, Title } from '@wyz/ui';
import * as React from 'react';
import { Trans } from '~/common/context';
import {
  IBrandTemplateWithBrands,
  IQuoteBrandTemplateWithBrands,
} from '~/connect/types';
type Props = {
  isLoading: boolean;
  brandTemplateLabel: React.ReactNode;
  matchedBrandTemplate:
    | IQuoteBrandTemplateWithBrands
    | IBrandTemplateWithBrands
    | null
    | undefined;
};

const BaseBrandsForm = ({
  isLoading,
  brandTemplateLabel,
  matchedBrandTemplate,
}: Props) => {
  return (
    <Card>
      <Card.Header>
        <Title heading='lg' color='tertiary' weight='bold'>
          {brandTemplateLabel}
        </Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <FormGroup>
            {brandTemplateLabel && <Label>{brandTemplateLabel}</Label>}
            <Text heading='normal' weight='semi-bold'>
              {isLoading ? (
                <Icon icon='spinner' size='xs' />
              ) : (
                (matchedBrandTemplate?.name ?? '-')
              )}
            </Text>
          </FormGroup>
        </Row>
        <hr />

        <div className='bg-neutral-grey-1 border rounded-3 border-neutral-grey-4 p-3'>
          <Table>
            <thead>
              <tr className='fs-xs'>
                <th>
                  <Trans i18nKey='app.common.rank' />
                </th>
                <th>
                  <Trans i18nKey='app.entity.form.suppliers_table.name_header' />
                </th>
              </tr>
            </thead>
            <tbody className='text-title-color fw-semi-bold'>
              {matchedBrandTemplate?.brands.map((brand, index) => (
                <tr key={brand.publicKey}>
                  <td>{index + 1}</td>
                  <td>{brand.name}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BaseBrandsForm;
